import { InfoCircleFilled } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Input, Modal } from 'antd';
import Button from 'antd/es/button';
import SMSCaptchaButton from 'components/SMSCaptchaButton';
import React, { useState } from 'react';
import { sendSMSCaptcha } from 'services/api/admin';
import errorToaster from 'utils/errorToaster';

interface Props {
  show: boolean;
  onClose: () => void;
  onLoginWithSmsCode: (code: string) => void;
  mobile?: string;
}
const NoMobileContent = styled.div`
  text-align: center;
  .info-icon {
    margin-top: 80px;
    color: #e6a539;
    width: 40px;
    height: 40px;
    svg {
      width: 40px;
      height: 40px;
    }
  }
  .title {
    font-weight: 500;
    font-size: 16px;
  }
  .sub-title {
    font-style: 14px;
    margin-top: 16px;
    margin-bottom: 77px;
  }
`;

const HasMobileContent = styled.div`
  text-align: center;
  .notice {
    height: 40px;
    background-color: #fffaf0;
    line-height: 40px;
    text-align: c;
  }
  .info-icon {
    color: #e6a539;
  }
  .title {
    margin-top: 57px;
  }
  .mobile {
    margin-top: 8px;
    font-weight: 900;
    font-size: 22px;
  }
  .sms-code {
    margin-top: 32px;
    display: flex;
  }
  .btn-group {
    margin-top: 70px;
    padding: 12px 0;
    text-align: center;
    button + button {
      margin-left: 32px;
    }
  }
`;

const SecurityPopup = React.memo((props: Props) => {
  const { show, onClose, mobile, onLoginWithSmsCode } = props;
  const [smsCode, setSmsCode] = useState('');
  const desensitization = (mobile: string) => {
    const len = mobile.length;
    return len > 7 ? `${mobile.substring(0, 7)}****${mobile.substring(11)}` : mobile;
  };
  const fetch = async (mobile: string) => {
    try {
      await sendSMSCaptcha({ phoneNumber: mobile, purpose: 'verify' });
    } catch (error) {
      errorToaster(error, '发送验证码失败');
      return 0;
    }
    return 60;
  };
  if (!mobile) {
    return (
      <Modal
        visible={show}
        onCancel={onClose}
        closable={false}
        title={null}
        cancelText={null}
        footer={null}
        maskClosable={false}
      >
        <NoMobileContent>
          <InfoCircleFilled className="info-icon" />
          <div className="title">您的帐号未绑定手机号码</div>
          <div className="title">请联系管理员操作绑定手机号码</div>
          <div className="sub-title">管理员可在「客服管理-{'>'}客服帐号管理」中补充信息哦</div>
          <Button onClick={onClose} type="primary">
            好的，我知道了
          </Button>
        </NoMobileContent>
      </Modal>
    );
  }

  return (
    <Modal
      visible={show}
      onCancel={onClose}
      closable={false}
      title={null}
      cancelText={null}
      footer={null}
      maskClosable={false}
    >
      <HasMobileContent>
        <div className="notice">
          <InfoCircleFilled className="info-icon" />
          系统监测到您的帐号存在异常，本次登录需要短信验证哦！
        </div>
        <div className="title">帐号绑定手机号码</div>
        <div className="mobile">{desensitization(mobile)}</div>
        <div className="sms-code">
          <Input
            onChange={(e) => setSmsCode(e.target.value)}
            maxLength={6}
            placeholder="请输入验证码"
          />
          <SMSCaptchaButton fetch={() => fetch(mobile)}>获取验证码</SMSCaptchaButton>
        </div>
        <div className="btn-group">
          <Button onClick={onClose}>暂不登录</Button>

          <Button
            onClick={() => onLoginWithSmsCode(smsCode)}
            type="primary"
            disabled={smsCode.length !== 6}
          >
            验证登录
          </Button>
        </div>
      </HasMobileContent>
    </Modal>
  );
});

export default SecurityPopup;
